import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { api } from '../properties/endpoints';

@Injectable({
  providedIn: 'root'
})
export class SearchFilterService {
  private searchValue = '';

  constructor(private http: HttpClient) { }
  searchFilter(page, value, keys: string[]) {
    let resultJsonAttributes = [];
    resultJsonAttributes = keys.map(key => ({
      key,
      value,
      operator: 'eq'
    }));
    const url = keys.length > 1 ? `${api.host}/${page}/search?or=true` : `${api.host}/${page}/search`;
    return this.http.post<any>(url, resultJsonAttributes);
  }
  setSearchValue(val: string) {
    this.searchValue = val;
  }
  getSearchValue(): string {
    return this.searchValue;
  }
}
